import React from "react";
import MobileTransactionItem from "../../transactions/MobileTransactionItem";
import { getCategoryIcon } from "../../utils/categoryIcons";
import { formatAmount } from "../desktop/transactionGroupingUtils";

export default function MobileTransactionGroup({
    groupKey,
    title,
    transactions,
    totalAmount,
    isCollapsed,
    onToggleCollapse,
    isSpecial = false,
    categoryLookup,
    tagLookup,
    approvalMode,
    removeTransactionCallback,
    showSaveError,
    showSaveSuccess,
    selectionMode = false,
    selectedTransactions = new Set(),
    onTransactionLongPress,
    onTransactionSelection
}) {
    return (
        <div style={{
            marginBottom: "10px"
        }}>
            <div
                onClick={() => onToggleCollapse(groupKey)}
                style={{
                    backgroundColor: isSpecial ? "#FFF9E6" : "#F0F0F0",
                    padding: "12px 15px",
                    cursor: "pointer",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    direction: "rtl",
                    borderRadius: "8px",
                    margin: "0 10px",
                    boxShadow: "0 2px 4px rgba(0,0,0,0.1)"
                }}
            >
                <div style={{ display: "flex", alignItems: "center", gap: "10px", flexWrap: "wrap" }}>
                    <span style={{ fontSize: "16px", color: "#666" }}>
                        {isCollapsed ? '◀' : '▼'}
                    </span>
                    {!isSpecial && (
                        <span style={{ fontSize: "18px" }}>
                            {getCategoryIcon(title)}
                        </span>
                    )}
                    <span style={{ fontSize: "15px", fontWeight: "600", color: "#333" }}>
                        {title}
                    </span>
                    <span style={{
                        fontSize: "12px",
                        color: "#999",
                        backgroundColor: "white",
                        padding: "3px 10px",
                        borderRadius: "12px",
                        border: "1px solid #E0E0E0",
                        fontWeight: "500"
                    }}>
                        {transactions.length}
                    </span>
                    {totalAmount !== undefined && (
                        <span style={{
                            fontSize: "13px",
                            fontWeight: "600",
                            color: "#2196F3",
                            backgroundColor: "#E3F2FD",
                            padding: "4px 10px",
                            borderRadius: "12px",
                            border: "1px solid #90CAF9"
                        }}>
                            ₪{formatAmount(totalAmount)}
                        </span>
                    )}
                </div>
                {isSpecial && (
                    <span style={{
                        color: "#F57C00",
                        fontSize: "12px",
                        fontWeight: "500"
                    }}>
                        ⚠️ דורש בירור
                    </span>
                )}
            </div>
            {!isCollapsed && (
                <div style={{ marginTop: "5px" }}>
                    {transactions.map((item) => (
                        <MobileTransactionItem
                            key={item.id}
                            item={item}
                            categoryLookup={categoryLookup}
                            tagLookup={tagLookup}
                            approvalMode={approvalMode}
                            removeTransactionCallback={removeTransactionCallback}
                            showSaveError={showSaveError}
                            showSaveSuccess={showSaveSuccess}
                            selectionMode={selectionMode}
                            isSelected={selectedTransactions.has(item.id)}
                            onLongPress={onTransactionLongPress}
                            onSelectionChange={onTransactionSelection}
                        />
                    ))}
                </div>
            )}
        </div>
    );
}